import { render, staticRenderFns } from "./certificateIntroductionList.vue?vue&type=template&id=c2c6ef12"
import script from "./certificateIntroductionList.vue?vue&type=script&lang=js"
export * from "./certificateIntroductionList.vue?vue&type=script&lang=js"
import style0 from "./certificateIntroductionList.vue?vue&type=style&index=0&id=c2c6ef12&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports